import React, { FC } from "react";
import { useFormatter } from "kw/util/useFormatter";
import { TQuote } from "kw/types";
import { Link } from "kanopi-components/Link";
import { navigate } from "@reach/router";
import { SummaryTable } from "./SummaryTable";

type TAdminRenewalsSection = {
  renewalQuote: TQuote;
};
export const AdminRenewalsSection: FC<TAdminRenewalsSection> = ({ renewalQuote }) => {
  const { formatString, formatDate, formatCurrency } = useFormatter();

  const quoteDetails = [
    {
      id: "quote-id",
      label: "Quote ID",
      value: (
        <Link
          title={renewalQuote?.id}
          onClick={() => navigate(`/admin/quotes/${renewalQuote?.id}`)}
        >
          {formatString(renewalQuote?.id)}
        </Link>
      ),
    },
    {
      id: "payment-frequency",
      label: "Payment frequency",
      value: formatString(renewalQuote?.paymentFrequency),
    },
    {
      id: "insurer",
      label: "Insurer",
      value: formatString(renewalQuote?.product?.provider?.name),
    },
    {
      id: "quote-status",
      label: "Quote status",
      value: formatString(renewalQuote?.stateDisplay),
    },
    {
      id: "created",
      label: "Created",
      value: formatDate(renewalQuote?.createdTimestamp),
    },
    {
      id: "amount-due",
      label: "Amount due",
      value: formatCurrency(renewalQuote?.amountDue),
    },
  ];

  return <SummaryTable data={quoteDetails} type="QUOTE" />;
};
